
import React from 'react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { sanitizeUrl } from "@/utils/formatters";
import { cn } from '@/lib/utils';

interface DetailItemProps {
  icon?: React.ReactNode;
  label: string;
  value?: string | number | null | React.ReactNode;
  isLink?: boolean;
  linkHref?: string | null;
  linkText?: string;
  className?: string;
}

export const DetailItem: React.FC<DetailItemProps> = ({ icon, label, value, isLink, linkHref, linkText, className }) => {
  const displayValue = value === undefined || value === null || (typeof value === 'string' && value.trim() === '') ? 'N/A' : value;
  
  return (
    <div className={cn("flex items-start space-x-3 py-2 group", className)}>
      {icon && <div className="text-muted-foreground mt-1">{icon}</div>}
      <div className="flex-1">
        <p className="text-sm font-medium text-gray-500">{label}</p>
        {isLink && linkHref ? (
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <a
                  href={sanitizeUrl(linkHref)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-primary hover:underline truncate"
                >
                  {linkText || (typeof displayValue === 'number' ? displayValue.toString() : displayValue)}
                </a>
              </TooltipTrigger>
              <TooltipContent>
                <p>{linkHref}</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        ) : (
          <div className="text-sm text-gray-900 break-words mt-0.5">
            {typeof displayValue === 'string' && displayValue.length > 100 && !React.isValidElement(displayValue) ? 
              <TooltipProvider>
                <Tooltip>
                  <TooltipTrigger asChild>
                    <span>{displayValue.substring(0,100)}...</span>
                  </TooltipTrigger>
                  <TooltipContent>
                    <p className="max-w-xs whitespace-pre-wrap">{displayValue}</p>
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
              : displayValue
            }
          </div>
        )}
      </div>
    </div>
  );
};
